import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";

import {deletedFaculty, deletedRestoreFaculty, setFaculty, setFacultyRestoreData} from "./facultySlice";
import {IErrorResponse, IRootState} from "../../../../types";
import {IFacultyCreate, IFacultyPayload} from "../types";


const GetFaculty = createAsyncThunk(
  "get/faculty",
  async (_, { dispatch, rejectWithValue,getState }) => {
    try {
      const response = await request.get("/faculties");
        const lang = getState()  as IRootState
        const defaultLanguage = lang.languages.defaultLanguage
      dispatch(setFaculty({data:response.data,defaultLanguage}));
      return response.data;
    }  catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");


    }
  }
);

const CreateFaculty = createAsyncThunk(
  "create/faculty",
  async (data: IFacultyCreate, { dispatch, rejectWithValue }) => {
    try {
      const response = await request.post("/faculties", data);

      dispatch(setFaculty(response.data));
      return response.data;
    }  catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");


    }
  }
);

const DeleteFaculty = createAsyncThunk(
  "delete/faculty",
  async ( id : number, { dispatch ,rejectWithValue}) => {
    try {
      const response = await request.delete(`/faculties/${id}`);



      dispatch(deletedFaculty(id));
      return response.data;
    }  catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");


    }
  }
);


const GetDeleteFaculty = createAsyncThunk(
    "get/delete/faculty",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/faculties/deleted-items`);

             dispatch(setFacultyRestoreData(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");


        }
    }
);

const RestoreDeleteFaculty = createAsyncThunk(
    "delete/delete/faculty",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/faculties/restore/${id}`);

             dispatch(deletedRestoreFaculty(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");


        }
    }
);



const EditFaculty = createAsyncThunk(
  "edit/faculty",
  async (data: IFacultyPayload, {  rejectWithValue }) => {
    try {
      const response = await request.put(`/faculties/${data.id}`, data);

      return response.data;
    }  catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");


    }
  }
);

export {
    GetFaculty,
    CreateFaculty,
    DeleteFaculty,
    EditFaculty,
    GetDeleteFaculty,
    RestoreDeleteFaculty

};
